import { StyleSheet } from "@react-pdf/renderer";
import { lightTheme, pdfColors } from "../../../../assetsConfig";

export const rem = 16;

const serif = lightTheme.fontBrand.fontFamily;
const sans = lightTheme.fontHeading.fontFamily;
const size = lightTheme.xxxSmallSize;
const smallestText = "10pt";

export const styles = StyleSheet.create({
	page: {
		display: "flex",
		flexDirection: "column",
		backgroundColor: lightTheme.colorBackgroundLightLight,
		fontSize: size,
		fontFamily: sans,
		padding: "32pt",
		color: lightTheme.colorCopyDarkDark,
	},
	flexCol: {
		display: "flex",
		flexDirection: "column",
	},
	flexRow: {
		display: "flex",
		flexDirection: "row",
	},
	itemsCenter: {
		alignItems: "center",
	},
	justifyBetween: {
		justifyContent: "space-between",
	},
	wFull: {
		width: "100%",
	},
	mbHalf: {
		marginBottom: rem / 2,
	},
	mb1: {
		marginBottom: rem,
	},
	mb2: {
		marginBottom: rem * 2,
	},
	mt1: {
		marginTop: rem,
	},
	mt2: {
		marginTop: rem * 2,
	},
	logo: {
		height: rem * 1.75,
	},
	// Sans — page labels, eyebrows, column headers, body copy, table data
	eyebrow: {
		fontFamily: serif,
		fontSize: lightTheme.xxxSmallSize,
		textTransform: "uppercase",
		color: pdfColors.textLight,
		letterSpacing: 0.5,
	},
	labelText: {
		fontFamily: serif,
		fontSize: size,
		textTransform: "uppercase",
		color: pdfColors.textLight,
	},
	smallColumnLabel: {
		fontFamily: serif,
		fontSize: smallestText,
		textTransform: "uppercase",
		color: pdfColors.textLight,
	},
	bodyText: {
		fontFamily: sans,
		fontSize: size,
		color: lightTheme.colorCopyDarkDark,
	},
	mutedText: {
		color: lightTheme.colorCopyLight,
	},
	serif: {
		fontFamily: serif,
	},
	sans: {
		fontFamily: sans,
	},
	smallestText: {
		fontSize: smallestText,
	},
	// Serif — section titles, order # (pages 1–2), ship-to name, entry titles, description
	sectionHeading: {
		fontFamily: serif,
		fontWeight: 700,
		fontSize: size,
		marginRight: rem,
	},
	orderNumber: {
		fontFamily: serif,
		fontWeight: 700,
		fontSize: lightTheme.h4Size,
	},
	entryNumber: {
		fontFamily: serif,
		fontWeight: 700,
		fontSize: lightTheme.h4Size,
	},
	serifTitle: {
		fontFamily: serif,
		fontWeight: 700,
		fontSize: lightTheme.pSize,
		color: lightTheme.colorCopyDarkDark,
	},
	serifBody: {
		fontFamily: serif,
		fontSize: size,
		color: lightTheme.colorCopyDarkDark,
		lineHeight: 1.4,
	},
	shipToName: {
		fontFamily: serif,
		fontWeight: 700,
		fontSize: lightTheme.h4Size,
		marginBottom: rem / 2,
	},
	divider: {
		borderBottom: `1px solid ${lightTheme.colorBorderLight}`,
		marginBottom: rem,
	},
	sectionHeadingRow: {
		flexDirection: "row",
		alignItems: "center",
		marginTop: rem * 1.5,
		marginBottom: rem,
	},
	sectionRule: {
		flex: 1,
		borderBottom: `1px solid ${lightTheme.colorBorderLight}`,
	},
	summaryTable: {
		flexDirection: "row",
		borderTop: `1px solid ${lightTheme.colorBorderLight}`,
		borderBottom: `1px solid ${lightTheme.colorBorderLight}`,
	},
	summaryColumnOrderId: {
		width: "15%",
		padding: rem / 2,
		borderRight: `1px solid ${lightTheme.colorBorderLight}`,
	},
	summaryColumnVertical: {
		width: "30%",
		padding: rem / 2,
		borderRight: `1px solid ${lightTheme.colorBorderLight}`,
	},
	summaryColumnCategory: {
		flex: 1,
		padding: rem / 2,
		borderRight: `1px solid ${lightTheme.colorBorderLight}`,
	},
	summaryColumnEntries: {
		width: "15%",
		padding: rem / 2,
	},
	instructionItem: {
		flexDirection: "row",
		marginBottom: rem / 2,
		fontSize: size,
		lineHeight: 1.4,
	},
	instructionNumberCol: {
		width: rem * 1.25,
		marginRight: rem / 2,
	},
	instructionNumber: {
		fontFamily: serif,
		fontWeight: 700,
		fontSize: size,
	},
	instructionTextCol: {
		flex: 1,
	},
	instructionText: {
		fontFamily: sans,
		fontSize: size,
	},
	cutOutEyebrow: {
		fontFamily: sans,
		textAlign: "center",
		marginBottom: rem / 2,
		fontSize: smallestText,
		textTransform: "uppercase",
		color: pdfColors.textLight,
	},
	cutOut: {
		border: `1px dashed ${lightTheme.colorBorderDark}`,
		padding: rem / 2,
		flex: 1,
	},
	addressBlock: {
		flex: 1,
		paddingRight: rem / 2,
	},
	tableHeaderRow: {
		flexDirection: "row",
		borderBottom: `1px solid ${lightTheme.colorCopyDarkDark}`,
		paddingVertical: rem / 4,
		marginTop: rem / 2,
	},
	tableHeaderText: {
		fontFamily: serif,
		fontSize: smallestText,
		textTransform: "uppercase",
		color: pdfColors.textLight,
	},
	tableRow: {
		flexDirection: "row",
		borderBottom: `1px solid ${lightTheme.colorBorderLight}`,
		paddingVertical: rem / 4,
		alignItems: "center",
		fontSize: size,
		fontFamily: sans,
	},
	checkBox: {
		width: rem / 2,
		height: rem / 2,
		border: `1px solid ${lightTheme.colorBorderDark}`,
		marginRight: rem / 2,
	},
	colCheck: {
		width: "6%",
		paddingRight: rem / 4,
	},
	colEntry: {
		width: "14%",
		paddingHorizontal: rem / 4,
		fontFamily: sans,
		color: lightTheme.colorCopyLight,
	},
	colAward: {
		width: "26%",
		paddingHorizontal: rem / 4,
		fontFamily: sans,
		color: lightTheme.colorCopyLight,
	},
	colProgram: {
		width: "27%",
		paddingHorizontal: rem / 4,
		fontFamily: sans,
	},
	colCategory: {
		width: "27%",
		paddingHorizontal: rem / 4,
		fontFamily: sans,
	},
	footerRow: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginTop: "auto",
		fontSize: smallestText,
		fontFamily: sans,
		borderTop: `1px solid ${lightTheme.colorBorderLight}`,
		paddingTop: rem / 4,
	},
	footerEnclosedGroup: {
		flexDirection: "row",
		alignItems: "center",
	},
	footerEnclosedLabel: {
		fontFamily: sans,
		fontSize: smallestText,
		color: pdfColors.textLight,
		marginRight: rem / 2,
	},
	enclosedCheckBox: {
		width: rem,
		height: rem,
		border: `1px solid ${lightTheme.colorBorderDark}`,
	},
	entryCoverImg: {
		width: rem * 4,
		height: rem * 4,
		objectFit: "cover",
	},
	entryCoverImageLarge: { width: rem * 8, height: rem * 8, objectFit: "cover" },
	metaGrid: {
		flexDirection: "column",
		flexWrap: "wrap",
		marginTop: rem / 2,
	},
	metaItem: {
		flexDirection: "row",
		flexWrap: "wrap",
		alignItems: "center",
		gap: rem / 4,
		marginBottom: rem / 2,
	},
	metaValue: {
		fontFamily: sans,
		fontWeight: 600,
		fontSize: size,
	},
	adminBox: {
		flexDirection: "row",
		justifyContent: "space-between",
	},
	qrCode: {
		width: rem * 4,
		height: rem * 4,
	},
});
